//
// ScatterPlotMatrix.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/DataVisualization";
import "../data/PlotRole";
import "../core/ColorModel";
import "../data/AnalysisRole";
import "../data/Role";
import "../core/styles/TextAttributes";
import "../core/DataLabelPosition";
import "../core/TextSplitJustify";
import "../layoutOverlay/LayoutOverlay";
import "./MatrixEllipseParm";
import "../data/ClassificationRole";
import "../data/GroupOrder";
import "../inset/Inset";
import "../inset/InsetOptions";
import "../core/styles/MarkerAttributes";
import "./ScatterPlotMatrixType";
import "../layoutOverlay/WallDisplay";
import "../core/MatrixStart";

var ScatterPlotMatrix = createModule("gtl::ScatterPlotMatrix", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization"], EventDispatcher, [
    ,
    {
        groupOrder: 4,
        labelStrip: 2,
        markerAttributes: 1,
        rowVars: [1],
        wallDisplay: 1,
        dataLabelSplitChar: 7,
        includeMissingGroup: 2,
        wallColor: 10,
        colorResponse: 1,
        dataLabelSplit: 2,
        dataLabelAttributes: 1,
        colorModel: 1,
        group: 1,
        dataLabelSplitJustify: 4,
        columnVars: [1],
        markerCharacter: 1,
        inset: 1,
        insetOptions: 1,
        dataLabel: 1,
        start: 4,
        index: 1,
        markerCharacterAttributes: 1,
        ellipses: [1],
        markerCharacterPosition: 4,
        matrixType: 4,
        reverseColorModel: 2,
        dataLabelPosition: 4,
        dataLabelSplitCharDrop: 2,
        diagonal: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ScatterPlotMatrix;
